module.exports = __webpack_public_path__ + "static/media/pointer.c2488b31.svg";